import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import Stream from './Stream'
import { AttendActivityContainer } from 'LiveBoard/components/shared/LiveEvent/AttendActivity'
import { getActivityType, EVENT_TYPES } from 'LiveBoard/components/shared/LiveEvent/AttendActivity/helpers'

import './style.css.scss'

const LiveEventStream = (props) => {
  const liveEventElement = useRef()

  return (
    <div className='live-event-stream-container' ref={liveEventElement}>
      <AttendActivityContainer
        themeColorHex={props.themeColorHex}
        attendActivityConfig={props.attendActivityConfig}
        boardId={props.boardId}
        activityType={getActivityType(EVENT_TYPES.stream, props.scheduleConfig)}
        hasAttendActivity={props.hasAttendActivityOverlay} />
      <Stream url={props.url} />
    </div>
  )
}

LiveEventStream.propTypes = {
  url: PropTypes.string.isRequired,
  themeColorHex: PropTypes.string,
  boardId: PropTypes.number,
  attendActivityConfig: PropTypes.object,
  hasAttendActivityOverlay: PropTypes.bool,
  scheduleConfig: PropTypes.object
}

export default LiveEventStream
